<template>
  <div class="error-container">
    <div class="error-content">
      <div class="error-icon">
        <i class="fa fa-lock"></i>
      </div>
      <h1>403</h1>
      <h2>Access Denied</h2>
      <p>Sorry, you don't have permission to access this page.</p>
      <div class="error-actions">
        <router-link to="/" class="btn btn-primary">
          <i class="fa fa-home me-2"></i>
          Back to Dashboard
        </router-link>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
// No additional logic needed
</script>

<style scoped>
.error-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background-color: #f8f9fa;
}

.error-content {
  text-align: center;
  padding: 2rem;
  max-width: 500px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.error-icon {
  font-size: 4rem;
  color: #dc3545;
  margin-bottom: 1rem;
}

h1 {
  font-size: 5rem;
  font-weight: bold;
  color: #dc3545;
  margin: 0;
  line-height: 1;
}

h2 {
  font-size: 2rem;
  color: #343a40;
  margin: 1rem 0;
}

p {
  color: #6c757d;
  margin-bottom: 2rem;
}

.error-actions {
  margin-top: 2rem;
}

.btn {
  padding: 0.75rem 1.5rem;
  font-size: 1rem;
  text-decoration: none;
  border-radius: 4px;
  transition: all 0.3s ease;
}

.btn-primary {
  background-color: #0d6efd;
  color: white;
  border: none;
}

.btn-primary:hover {
  background-color: #0b5ed7;
  transform: translateY(-2px);
}

.me-2 {
  margin-right: 0.5rem;
}

/* Animation for the error content */
.error-content {
  animation: fadeIn 0.5s ease-out;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Responsive adjustments */
@media (max-width: 576px) {
  .error-content {
    padding: 1.5rem;
    margin: 1rem;
  }

  h1 {
    font-size: 4rem;
  }

  h2 {
    font-size: 1.5rem;
  }
}
</style>